import { render } from "./mutitabs.vue?vue&type=template&id=acba46e6"
import script from "./mutitabs.vue?vue&type=script&lang=js"
export * from "./mutitabs.vue?vue&type=script&lang=js"

import "./mutitabs.vue?vue&type=style&index=0&id=acba46e6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__